// @flow

/**
 * Module dependencies.
 */

import { colors } from 'client/styles/colors';
import { h1, h2, h3, h4, paragraph, small, type } from 'client/styles/type';
import { injectGlobal } from 'styled-components';
import { normalizeCss } from 'client/styles/utils';
import { states } from 'client/styles/states';

/**
 * Global content types.
 */

const globalContentType = {
  h1,
  h2,
  h3,
  h4,
  p: paragraph, // eslint-disable-line id-length
  small
};

/**
 * Default font settings.
 */

const fontSettings = `
  margin: 0 0 1rem;

  -webkit-font-feature-settings: 'calt', 'clig', 'kern', 'liga', 'locl', 'rlig';
  font-feature-settings: 'calt', 'clig', 'kern', 'liga', 'locl', 'rlig';
`;

/**
 * Inject global styles.
 */

/* eslint-disable no-unused-expressions */
injectGlobal`
  body {
    color: ${colors.shadesOfBlue.oxfordBlue};
    font-family: ${type.fontFamily.openSans};
    font-size: ${type.fontSizeBase};
    font-weight: 400;
    line-height: ${type.lineHeightBase};

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ${normalizeCss(globalContentType, fontSettings)}

  svg {
    display: block;
  }

  .form-label {
    display: block;
    line-height: 16px;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-transition: color 9999s ease-out, background-color 9999s ease-out;
    -webkit-transition-delay: 9999s;
  }

  .link-primary {
    color: ${colors.brandPrimary};
    text-decoration: underline;

    transition: color .2s linear;

    ${states.interaction`
      color: ${colors.brandPrimaryDark};
    `};
  }

  .link-secondary {
    color: ${colors.brandSecondary};
    text-decoration: underline;

    transition: color .2s linear;

    ${states.interaction`
      color: ${colors.shadesOfBlue.oxfordBlue};
    `};
  }
`;
/* eslint-enable no-unused-expressions */



// WEBPACK FOOTER //
// ../src/client/styles/global.js